import { BASE_API_URL } from './index';

export const changePasswordEndpoint = (userId) => `${BASE_API_URL}/user/${userId}/change_password/`;
export const createPasswordEndpoint = `${BASE_API_URL}/user/create_password/`;
export const loginEndpoint = `${BASE_API_URL}/user/login/`;
export const logoutEndpoint = `${BASE_API_URL}/user/logout/`;
export const resetPasswordEndpoint = `${BASE_API_URL}/user/reset_password/`;
